import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from 'src/app/services/forms/form.service';
import { JoinUsService } from 'src/app/services/join-us/join-us.service';
import { JobOpening } from 'src/app/models/job-opening.interface';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

interface ApplicationFormData {
  name: string;
  email: string;
  address: string;
  dob: string;
  letter: string;
}

@Component({
    selector: 'app-job-desc',
    templateUrl: './job-desc.component.html',
    styleUrls: ['./job-desc.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JobDescComponent implements OnInit {
  jobId: string | null = null;
  slug: string | null = null;
  job: JobOpening | null = null;
  jobTitle: string = '';
  dept: string = '';
  backgroundImageUrl: string = 'assets/imgs/join_our_tribe/Operations.jpg';
  isLoading: boolean = true;
  error: string | null = null;
  
  @ViewChild('applicationForm') applicationForm: NgForm | undefined;
  experienceValue: string = '';
  window = window;

  constructor(
    private currentRoute: ActivatedRoute, 
    private jobService: JoinUsService, 
    private formService: FormService,
    private router: Router
  ) {
    this.slug = this.currentRoute.snapshot.paramMap.get('slug');
  }

  ngOnInit(): void {
    this.loadJob();
  }

  goBack(): void {
    if (this.job?.isExecutive) {
      this.router.navigate(['/executive-jobs']);
    } else {
      this.router.navigate(['/join-our-tribe']);
    }
  }

  private loadJob(): void {
    if (!this.slug) {
      this.error = 'No job slug provided';
      this.isLoading = false;
      return;
    }

    this.jobService.getJobBySlug(this.slug).subscribe({
      next: (job: JobOpening | undefined) => {
        if (job) {
          this.job = job;
          this.jobTitle = job.title || '';
          this.dept = job.department || '';
          this.backgroundImageUrl = job.departmentImageUrl || 'assets/imgs/join_our_tribe/Operations.jpg';
          this.error = null;
        } else {
          this.error = 'Job not found';
        }
        this.isLoading = false;
      },
      error: (err: Error) => {
        this.error = 'Failed to load job details';
        this.isLoading = false;
        console.error('Error loading job:', err);
      }
    });
  }

  onSubmitApplication(applicationForm: NgForm): void {
    if (!applicationForm.valid) {
      return;
    }

    const fileInput = document.getElementById('inputGroupFile01') as HTMLInputElement;
    const uploadedFile = fileInput.files?.[0];

    if (!uploadedFile) {
      console.warn('No file selected');
      return;
    }

    const formData = new FormData();
    const formValue: ApplicationFormData = applicationForm.value;
    
    formData.append('name', formValue.name);
    formData.append('email', formValue.email);
    formData.append('address', formValue.address);
    formData.append('dob', formValue.dob);
    formData.append('experience', String(this.experienceValue));
    formData.append('letter', formValue.letter);
    formData.append('pdfFile', uploadedFile, uploadedFile.name);

    this.formService.postApplicant(formData).subscribe({
      next: (res: unknown) => {
        console.log('Application submitted successfully', res);
        applicationForm.reset();
        alert('Application submitted successfully!');
      },
      error: (err: Error) => {
        console.error('Error submitting application:', err);
        alert('Failed to submit application. Please try again.');
      }
    });
  }

  copyLink(): void {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(() => {
      alert('Link copied to clipboard!');
    }).catch((err: Error) => {
      console.error('Could not copy link: ', err);
    });
  }
}
